module.exports = __webpack_public_path__ + "media/images/icons/check-b9818f954fc8f04902fda09a0afca274.svg";